@if (slides) {
  <ngb-carousel #carousel class="carousel-dark">
    @for (slide of slides; track slide) {
      <ng-template ngbSlide>
        <div class="carousel-caption d-none d-md-block">
          <wagtail-page-element-full-bleed-slider-caption [slide]="slide"></wagtail-page-element-full-bleed-slider-caption>
        </div>
        <div class="picsum-img-wrapper">
          @if (slide.picture_tag_info) {
            <wagtail-page-element-image
              [image]="slide.picture_tag_info"
            ></wagtail-page-element-image>
          }
        </div>
      </ng-template>
    }
  </ngb-carousel>
}
